export type FeedbackSurveyType = 'renewal' | 'feedback';

export function parseFeedbackSurveyType(param: string | null): FeedbackSurveyType | null {
  if (param === 'renewal' || param === 'feedback') return param;
  return null;
}
